import i18n from "@/i18n";
import { Vue } from "vue-property-decorator";
import { ConfigStore } from "fs-pb-vue2/store/modules/config";
import { getModule } from "vuex-module-decorators";

export class SupportVueGB extends Vue {

  dialog: boolean = false;

  async callAction(action: () => Promise<any>) {
    await action();
  }

  /**Закрытие формыы */
  async destroyForm(): Promise<void> {
    this.$emit("hideSelf");
  }

  /** контент диалогового окна */
  dialogContent: any = {};
  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get actions(): Array<any> {
    const actions: Array<any> = [];
    actions.push({
      /** Связь с банком */
      text: i18n.t("main.support.connectionBank"),
      iconClass: "call-phone-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "ConnectionBankModal",
        });
        this.dialog = true;
      }
    });

    if (this.configStore.apiData.ChatEnable)
      actions.push({
        /** Чат с банком */
        text: i18n.t("main.support.chatBank"),
        iconClass: "chat-bank-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "Chat",
          });
          this.dialog = true;
        }
      });
    actions.push({
      /** Офисы и банкоматы */
      text: i18n.t("main.support.office"),
      iconClass: "office-bank-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "MapComponent",
        });
        this.dialog = true;
      }
    });
    return actions;
  }
}